import { APIClient } from "../api/client.js";
import { openModal } from "../components/Modal.js";
import { ResultView } from "../components/ResultView.js";
import type { ResultActions } from "../components/ResultView.js";
/**
 * RightPanel — colonne de droite persistante : résultat courant + historique.
 * Reste visible quel que soit le workspace actif.
 */
import { h } from "../components/dom.js";
import { store } from "../state/store.js";
import type { HistoryImage } from "../types/index.js";

export class RightPanel {
	readonly element: HTMLElement;
	private readonly historyGrid: HTMLElement;
	private readonly historyBlock: HTMLElement;
	private readonly resultView: ResultView;
	private historyCount = 0;

	constructor(resultActions: ResultActions = {}) {
		this.historyGrid = h("div", { class: "history-grid" });
		this.resultView = new ResultView(resultActions);
		this.historyBlock = h(
			"div",
			{ hidden: true },
			h("h3", { class: "card-title" }, "Historique"),
			this.historyGrid
		);
		this.element = h(
			"aside",
			{ class: "app-rightpanel" },
			this.resultView.element,
			this.historyBlock
		);
		store.subscribe(
			(s) => s.historyVersion,
			() => void this.refreshHistory()
		);
		store.subscribe(
			(s) => s.currentResult,
			() => this.markIdle()
		);
		store.subscribe(
			(s) => s.run,
			() => this.markIdle()
		);
		this.markIdle();
		void this.refreshHistory();
	}

	/**
	 * Nothing to show yet: no result, nothing running, no history. Stacked
	 * under the form on a narrow screen (shell.css), the empty column then
	 * filled a whole phone screen; it stays out of the way until it has
	 * something to say.
	 */
	private markIdle(): void {
		const state = store.get();
		const idle = !state.currentResult && !state.run && this.historyCount === 0;
		this.element.classList.toggle("is-idle", idle);
	}

	setResultActions(actions: ResultActions): void {
		this.resultView.setActions(actions);
	}

	async refreshHistory(): Promise<void> {
		let images: HistoryImage[] = [];
		try {
			images = await APIClient.getHistory();
		} catch {
			// Historique indisponible (mode hosted sans stockage local) : zone vide.
		}
		this.historyCount = images.length;
		this.historyBlock.hidden = images.length === 0;
		this.markIdle();
		this.historyGrid.replaceChildren(
			...images.map((img) =>
				h(
					"button",
					{
						class: "history-item",
						type: "button",
						title: img.filename,
						onclick: () => this.openLightbox(img),
					},
					h("img", { src: img.url, alt: img.filename, loading: "lazy" })
				)
			)
		);
	}

	private openLightbox(img: HistoryImage): void {
		openModal({
			title: img.filename,
			content: h("img", { src: img.url, alt: img.filename }),
			actions: [{ label: "Fermer", kind: "primary", onClick: () => undefined }],
		});
	}
}
